<div>
  <div class="is-online">
    <mat-checkbox
      name="isOnline"
      [(ngModel)]="additionalInfo.isOnline"
      [disabled]="!editMode">
      Online Gym
    </mat-checkbox>
  </div>
  <mat-form-field class="form-column">
    <mat-label>Area</mat-label>
    <input
      matInput
      placeholder="Area"
      [disabled]="!editMode"
      [(ngModel)]="additionalInfo.area"
      name="area"
      id="additionalInfo.area"
      type="number" />
  </mat-form-field>

  <mat-form-field class="form-column">
    <mat-label>Pool length</mat-label>
    <input
      matInput
      placeholder="Pool length"
      [disabled]="!editMode"
      [(ngModel)]="additionalInfo.poolLength"
      name="poolLength"
      id="additionalInfo.poolLength"
      type="number" />
  </mat-form-field>
</div>
